module.exports = __webpack_public_path__ + "img/wms.d2d9e6b6.svg";